module.exports = __webpack_public_path__ + "static/gate-installation-img-2053981547b5db073347c26f9707266f.jpg";